<template>
  <div class="error-page">
    <h4 class="pa-4 white--text">
      {{
        error_msg ||
        "Errore inatteso. Refreshare la pagina. Se il problema persiste contattare il supporto"
      }}
    </h4>
  </div>
</template>

<script>
export default {
  name: "error",
  data() {
    return {};
  },
 props: {
    error_msg: {
      type: String,
      default: ""
    },
  },
  mounted() {
    console.log("--> Error ready.");
  },
  destroyed() {
    console.log("<-- Error destroyed.");
  },
};
</script>


<style lang="scss" scoped>
@import "../../main.scss";
.error-page {
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  background-color: var(--v-primary-base);
}
</style>
